import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import topdf from "../../ToPDF";
import Button from "@material-ui/core/Button";

function getModalStyle() {
  return {
    textAlign: "center",
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)"
  };
}

const useStyles = makeStyles(theme => ({
  paper: {
    position: "absolute",
    width: "auto",
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 4),
    outline: "none",
    textAlign: "center"
  }
}));

export default function SimpleModal(props) {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  //const [email, setEmail] = React.useState();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleToPDF = (m2, email) => {
    topdf(m2, email);
  };

  

  const sendEmail = () => {
    handleToPDF(props.currentM2asked, props.email);
    handleClose();
  }

  return (
    <div style={props.style}>
      <Button variant="contained" onClick={handleOpen}>
        Enviar Presupuesto
      </Button>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={handleClose}
        overflow="scroll"
      >
        <div style={modalStyle} className={classes.paper}>
          <TextField
            id="outlined-with-placeholder"
            label="Email"
            placeholder="Email"
            margin="normal"
            variant="outlined"
            onChange={props.handleOnChangeEmail}
          />
          <div>
            <Button
              variant="contained"
              onClick={sendEmail}
            >
              Enviar Email
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
